<template>
  <div class="col-12 table-container">
    <va-input
      type="text"
      v-model="querySearch"
      :removable="true"
      :placeholder="$t('activities_agenda.agenda.person_search')"
    />

    <v-server-table
      v-show="canShowTable"
      class="pt-3"
      :columns="columns"
      :options="tableOptions"
      id="peopleTable"
      ref="peopleTable"
      name="peopleTable"
      @row-click="onPersonClicked">
                <span slot="name" slot-scope="{row}">
                  {{row.firstName + ' ' + row.lastName || "N/A"}}
                </span>
      <span slot="mobilePhone" slot-scope="{row}">
                  {{row.mobilePhone || "N/A"}}
                </span>
      <span slot="email" slot-scope="{row}">
                  {{row.email || "N/A"}}
                </span>
      <span slot="birthdate" slot-scope="{row}">
                  {{row.birthdate ? moment(row.birthdate).format("DD/MM/YYYY") : "N/A"}}
                </span>

    </v-server-table>
    <div class="is-bold col-12 text-center pt-2" v-show="!canShowTable">
      {{$t('people_manager.no_results')}}
    </div>


  </div>
</template>

<script>
import TableQueryMixin from "@/mixins/TableQueryMixin.vue";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder.vue";

export default {
  name: "PeopleSelector",
  components: { LoadingPlaceholder },
  mixins: [TableQueryMixin],
  mounted: function () {
    this.$refs.peopleTable.setLimit(5)
  },
  data () {
    return {
      selectedPerson: null,
      //queryUrl: `${this.$store.state.people_manager_server}/v1/people?censored=false`,
      queryUrl: `${this.$store.state.people_manager_server}/v1/people/list`,
      columns: ['name', 'email', 'mobilePhone', 'birthdate'],
      querySearch: '',
      tableOptions: {
        columnsDropdown: false,
        sortable: [],
        filterable: true,
        skin: 'table table-striped table-hover is-fullwidth',
        headings: {
          name: this.$t('accounts.name'),
          mobilePhone: this.$t('people.inputs.mobile-phone'),
          email: this.$t('accounts.email'),
          birthdate: this.$t('clinical.people.birthday'),
        },
      },
    }
  },
  methods: {
    onPersonClicked: function ({row}) {
      this.selectedPerson = row
      this.$emit('selectedPerson', this.selectedPerson)
    },
  },
  computed: {
    canShowTable: function() {
      return this.querySearch.length > 3
    }
  },
  watch: {
    querySearch: function(query) {
      if(query.length > 3) {
        this.$refs.peopleTable.setFilter(query)
      } else {
        this.$emit('selectedPerson', null)
      }
    }
  }
};
</script>

